__turbopack_context__.v({
  "SButton": "_2ZoGAq_SButton",
  "SWatchListLabel": "_2ZoGAq_SWatchListLabel",
  "SWatchlistSvg": "_2ZoGAq_SWatchlistSvg",
  "ThemeDk": "_2ZoGAq_ThemeDk",
  "ThemeFw": "_2ZoGAq_ThemeFw",
  "Variant_Dark": "_2ZoGAq_Variant_Dark",
  "Variant_Light": "_2ZoGAq_Variant_Light",
});
